export const EMAILS_DEFAULT_STATE = {
  items: [],
};

function emailsReducer(state = EMAILS_DEFAULT_STATE, action) {
  switch (action.type) {
    // Add Email

    case "ADD_EMAIL":
      return {
        ...state,
        addEmailLoading: true,
        addEmailSaving: true
      };

    case "ADD_EMAIL_SUCCESS":
      return {
        ...state,
        items: state.items.concat({
          ...action.email,
          __type: "email"
        }),
        addEmailLoading: false,
        addEmailSaving: false,
        addEmailSuccess: true,
        addEmailError: null
      };

    case "EMAIL_FAILURE":
      return {
        ...state,
        addEmailLoading: false,
        addEmailSaving: false,
        addEmailSuccess: false,
        addEmailError: action.error
      };

    default:
      return state;
  }
}

export default emailsReducer;
